(function($) {
    $.fn.changeElementType = function(newType) {
        var attrs = {};
        $.each(this[0].attributes, function(idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue;
        });
        this.replaceWith(function() {
            return $("<" + newType + "/>", attrs).append($(this).contents());
        });
    };
})(jQuery);

jQuery(document).ready(function ($) {

    $('.offer.las-upp-med-kod').remove();

    // Toggle Filter menus
    $( document ).on( 'click', '.property-toggle', function(){

        if ($(this).hasClass('active')) {

            $('.category-toggle').removeClass('active');
            $('.category-filter').removeClass('active');
            $('.date-toggle').removeClass('active');
            $('.date-filter').removeClass('active');
            $(this).removeClass('active');
            $('.property-filter').removeClass('active');

        } else {

            $('.category-toggle').removeClass('active');
            $('.category-filter').removeClass('active');
            $('.date-toggle').removeClass('active');
            $('.date-filter').removeClass('active');
            $(this).addClass('active');
            $('.property-filter').addClass('active');

        }


    });

    $( document ).on( 'click', '.category-toggle', function(){

        if ($(this).hasClass('active')) {

            $('.property-toggle').removeClass('active');
            $('.property-filter').removeClass('active');
            $('.date-toggle').removeClass('active');
            $('.date-filter').removeClass('active');
            $(this).removeClass('active');
            $('.category-filter').removeClass('active');

        } else {

            $('.property-toggle').removeClass('active');
            $('.property-filter').removeClass('active');
            $('.date-toggle').removeClass('active');
            $('.date-filter').removeClass('active');
            $(this).addClass('active');
            $('.category-filter').addClass('active');

        }

    });

    $( document ).on( 'click', '.date-toggle', function(){

        if ($(this).hasClass('active')) {

            $('.category-toggle').removeClass('active');
            $('.category-filter').removeClass('active');
            $('.property-toggle').removeClass('active');
            $('.property-filter').removeClass('active');
            $(this).removeClass('active');
            $('.date-filter').removeClass('active');

        } else {

            $('.category-toggle').removeClass('active');
            $('.category-filter').removeClass('active');
            $('.property-toggle').removeClass('active');
            $('.property-filter').removeClass('active');
            $(this).addClass('active');
            $('.date-filter').addClass('active');

        }

    });

    $('.property-filter .filter-btn').on('click', filterByProperty);
    $('.category-filter .filter-btn').on('click', filterByCategory);

    $( document ).on( 'change', '#guests, #rooms', function(){
        if ( $('#datepicker').val() ) {
            $('#datepicker').trigger('change');
        }
    });

    $( document ).on( 'change', '#datepicker', function(){
        $('.offers').css('display', 'none');
        $('.filter-wrp').after('<div class="offers-loading"></div>');

        var date = $(this).val();
        if ( date === '' ) {
            return;
        }
        var guests = $('#guests').children('option:selected').val();
        var rooms = $('#rooms').children('option:selected').val();
        var channel_ids = [];
        $('.property-filter').children('.active').each(function() {
            channel_ids.push( $(this).attr("data-channel") );
        });

        $('#packages').val('');

        $.ajax({
            url : "/wp-admin/admin-ajax.php",
            method : "post",
            data : {
                action: 'offers_by_date',
                date: date,
                guests: guests,
                rooms: rooms,
                channel_ids: channel_ids
            },
            success: function( result ) {

                $('.property-filter').children('.active').each(function() {
                    var $this = $(this);
                    var id = $this.data('id');
                    var index = currentPropertyFilters.indexOf(id);
                    if(index > -1) {
                        currentPropertyFilters.splice(index, 1);
                    }
                });

                var packages = result.data.packages;
                $('#packages').val( packages );

                var channels = result.data.channels;

                if ( channels.length === 0 ) {
                    $('.offers .offer').each(function () {
                        $(this).changeElementType('span');
                    });
                    update_count();
                } else {
                    $('.property-filter .filter-btn').removeClass('active').addClass('disabled');
                    $.each(channels,function(i){
                        var $this = $('.property-filter .filter-btn[data-channel=' + channels[i] + ']');
                        var id = $this.data('id');
                        currentPropertyFilters.push(id);
                        $this.addClass('active').removeClass('disabled');
                    });
                    executeFilter();
                }

                $('.date-toggle').text( date );
                $('.prop-count').addClass('active');
                $('.cat-count').addClass('active');

            }
        });
    });

    $( document ).on( 'click', '.ui-datepicker-close', function(){
        $('#datepicker').val('');
        $('.date-toggle').text('Datum');
        $('.property-filter .filter-btn').addClass('active').removeClass('disabled').trigger('click');
    });

    // Toggle offers
    var hash = window.location.hash.substring(1, window.location.hash.length);
    var parts = hash.split('+');
    var currentPropertyFilters = [];
    var currentCategoryFilters = [];
    var $offers_container = $('.offers');
    var $offers = $('.offers .offer');

    setTimeout(function(){
        if( window.location.hash ) {
            for(var i = 0, l = parts.length; i < l; ++i) {
                $('.filter-btn[data-id=' + parts[i] + ']').trigger('click');
            }
        }
    }, 200);

    function filterByProperty(e) {
        e.preventDefault();

        $('.prop-count').addClass('active');
        $('.cat-count').addClass('active');

        var $this = $(this);
        var id = $this.data('id');

        $('.property-filter .filter-btn').removeClass('all');
        $this.toggleClass('active');
        if($this.hasClass('active')) {
            currentPropertyFilters.push(id);
        } else {
            var index = currentPropertyFilters.indexOf(id);
            if(index > -1) {
                currentPropertyFilters.splice(index, 1);
            }
        }

        executeFilter();

    }

    function filterByCategory(e) {
        e.preventDefault();

        $('.prop-count').addClass('active');
        $('.cat-count').addClass('active');

        var $this = $(this);
        var id = $this.data('id');

        $('.category-filter .filter-btn').removeClass('all');
        $this.toggleClass('active');
        if($this.hasClass('active')) {
            currentCategoryFilters.push(id);
        } else {
            var index = currentCategoryFilters.indexOf(id);
            if(index > -1) {
                currentCategoryFilters.splice(index, 1);
            }
        }

        executeFilter();

    }

    function executeFilter() {

        $offers = $('.offers .offer');

        $offers.each(function () {
            $(this).changeElementType('span');
        });

        $offers = $('.offers .offer');

        var propertyHash = currentPropertyFilters.join('+');
        var categoryHash = currentCategoryFilters.join('+');
        var hash;

        for(var i = 0, l = $offers.length, $offer, id, hitPropertyFilter, hitCategoryFilter; i < l; ++i) {
            $offer = $($offers[i]);
            id = $offer.data('id');
            hitPropertyFilter = false;

            for(var j = 0, ll = currentPropertyFilters.length; j < ll; ++j) {
                var idArr = id.split(' ');
                if( $.inArray(currentPropertyFilters[j], idArr) === -1 ) {
                    continue;
                }

                hitPropertyFilter = true;
                break;
            }

            if(currentPropertyFilters.length === 0) {
                $('.property-filter .filter-btn').addClass('all');
                hash = propertyHash + categoryHash;
                document.location.hash = hash;
            } else {
                hash = propertyHash + '+' + categoryHash;
                document.location.hash = hash;
            }

            if(currentPropertyFilters.length > 0 && !hitPropertyFilter) {
                continue;
            }

            if(currentCategoryFilters.length === 0) {
                $offer.changeElementType('div');
                $('.category-filter .filter-btn').addClass('all');
            } else {
                for(var j = 0, ll = currentCategoryFilters.length; j < ll; ++j) {
                    if(id.indexOf(currentCategoryFilters[j]) === -1) {
                        continue;
                    }

                    $offer.changeElementType('div');
                    break;
                }
            }
        }

        update_count();

    }

    function update_count() {
        $('.no-offers').remove();

        if ( $('#packages').val() ) {
            var packages_array = $('#packages').val().split(',');

            $('div.offer').each(function() {
                var $this = $(this);
                var package_item = $this.data('package');

                if( $.inArray(package_item, packages_array) === -1 ) {
                    $this.changeElementType('span');
                }
            });

        }

        var cat_count = $offers_container.children('div').length;
        var props = {};
        var prop_count = 0;
        $offers_container.children('div[data-channel]').each(function() {
            var data = $(this).attr("data-channel");
            if(!props[data]) {
                props[data] = {};
                prop_count++;
            }
        });
        $('.prop-count').text( prop_count );
        $('.cat-count').text( cat_count );

        setTimeout(function() {
            $('.offers-loading').remove();
            $('.offers').css('display', 'block');
        }, 500);

        setTimeout(function() {
            $('.prop-count').removeClass('active');
            $('.cat-count').removeClass('active');
        }, 1000);

        if ( prop_count === 0 ) {
            if ( $('#datepicker').val() ) {
                $offers_container.prepend('<div class="no-offers">Det finns inget boende på valda destinationer som matchar antal personer eller datum.</div>');
            } else {
                $offers_container.prepend('<div class="no-offers">Valda destinationer matchade inte dina valda kategorier.</div>');
            }

        }
    }

});